import React from "react";
import defaultConfig from "./alme-config/appConfigMain";
import App from "./App";
import { isMobileDevice } from "./components/AlmeUtilities/device-utils";
import ErrorBoundary from "./components/ErrorBoundary/ErrorBoundary";
const getSessionId = () => {
    return sessionStorage.getItem("session_id") || undefined;
};
const IVAChat = (props) => {
    /**
     * Update function updateAppConfigState on adding new Node module specific props
     */
    const appConfig = Object.assign(Object.assign({}, defaultConfig), { main: {
            apiHostName: props.apiHostName,
            isLoggedIn: props.isLoggedIn,
            showIvaChatIcon: props.showIvaChatIcon,
            clientSessionId: props.clientSessionId,
            userMetadata: props.userMetadata,
            platform: props.platform,
            sessionId: getSessionId(),
        }, get webUrl() {
            return `https://${props.apiHostName}/Alme`;
        } });
    appConfig.isMobile = isMobileDevice();
    if (appConfig.isMobile) {
        appConfig.channel = "MobileWeb";
    }
    return (React.createElement(ErrorBoundary, { appConfig: appConfig },
        React.createElement(App, { isOpen: props.isOpen, onMinimize: props.onMinimize, onClose: props.onClose, appConfig: appConfig })));
};
export default IVAChat;
